module.exports = __webpack_public_path__ + "img/koningsdag.acd924e6.jpg";